<script>
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import Confirmation from '@/components/widgets/modals/Confirmation'
  export default {
    components: { Confirmation },
    mixins: [validationMixin],
    props: {
      title: {
        type: String,
        default: 'Set Interval'
      },
      message: {
        type: String,
        default: 'Yakin ingin mengatur interval?'
      },
      modal: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: null
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      region: {
        type: String,
        default: 'SG'
      },
    },
    data () {
      return {
        form: {
          selected: null
        },
        modalConfirm: false
      }
    },
    validations: {
      form : {
        selected: { required }
      }
    },
    computed: {
      showModal: {
        get() {
          return this.modal
        },
        set(newVal) {
          this.$emit('update:modal', newVal)
        }
      },
      loading: {
        get() {
          return this.isLoading
        },
        set(newVal) {
          this.$emit('update:isLoading', newVal)
        }
      }
    },
    methods: {
      handleOk(bvModalEvent) {
        bvModalEvent.preventDefault();
      },
      handleSubmit(bvModalEvent) {
        bvModalEvent.preventDefault();

        this.$v.form.$touch();
        if (this.$v.form.$error) {
          return;
        }
        this.modalConfirm = true
      },
      afterConfirm() {
        const payload = {
          online_command: this.form.selected
        }
        this.$emit('beforeSubmit', { payload })
      }
    }
  }
</script>
<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form"
      :title="title"
      size="md"
      centered
      :hide-header-close="loading"
      no-close-on-backdrop
    >
      <div class="card-body mc-modal__filter p-2">
        <b-form @submit.stop.prevent="handleSubmit">
          <div class="mb-2">
            <v-select
              v-model="form.selected"
              :options="options"
              placeholder="Pilih options"
              label="name"
              :reduce="v => v.id"
              :class="{
                'is-invalid': $v.form.selected.$error,
              }"
            >
            </v-select>
            <div v-if="$v.form.selected.$error" class="invalid-feedback">
              <span v-if="!$v.form.selected.required"> This field is required </span>
            </div>
          </div>
        </b-form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" :disabled="loading" class="me-3">
              Batal
            </b-button>
            <b-button @click="handleSubmit" variant="primary" :disabled="loading">
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Simpan' }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <confirmation
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      :message="message"
      @confirmed="afterConfirm"
    />
  </div>
</template>